// packages/mcp-server/src/featureFlags.ts — thin wrapper over the
// authoritative resolver in `./flags.ts` (byte copy of `convex/lib/flags_core.ts`
// via `npm run prebuild`; file is committed for Railway package-scoped Docker).
//
// Chain: DEC-701.
//
// `initFeatureFlags` is retained as a no-op for compatibility with the
// existing MCP bootstrap call sites (index.ts, http.ts). It used to create
// a PostHog client; with the DEC-701 allowlist registry PostHog is a
// per-flag opt-in via globalThis.__posthog, so no initialization is
// required at startup.
import type { PostHog } from "posthog-node";
import { isFeatureEnabled as coreIsFeatureEnabled, type FlagKey } from "./flags.js";

export type { FlagKey };

export function initFeatureFlags(_posthogClient: PostHog | null): void {
  // no-op — DEC-701 registry does not require a PostHog client at startup.
  // Retained so existing MCP boot code (index.ts, http.ts) keeps working.
}

export function isFeatureEnabled(
  flag: FlagKey,
  ctx: { workspaceId?: string; clerkUserId?: string } = {},
): boolean {
  return coreIsFeatureEnabled(flag, ctx);
}
